import React, { useState, useRef, useEffect } from 'react';
import { IoChevronDownOutline } from 'react-icons/io5';
import styles from './CustomDropdown.module.css';

const CustomDropdown = ({
  label,
  placeholder = 'Select an option',
  options = [],
  value,
  onChange,
  className,
  inputClass
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className={`${styles.wrapper} ${className || ''}`} ref={dropdownRef}>
      {label && <label className={styles.label}>{label}</label>}
      <div
        className={`${styles.inputContainer} ${inputClass}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className={styles.selectedText}>
          {value?.label || placeholder}
        </span>
        <IoChevronDownOutline className={styles.icon} color='#CECECE' />
      </div>

      {isOpen && (
        <div className={styles.dropdown}>
          {options.map((option, idx) => (
            <div
              key={idx}
              className={styles.option}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;